import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import config from '../../config/config'
import ManagePoiExternalLink from './ManagePoiExternalLink'
import { useAuth, AuthContext } from '../../contexts/AuthContext'
import { LOGIN_PATH } from '../../config/routes'
import { useWebsite, setFlashMessage } from '../../contexts/WebsiteContext'

const ManagePoiExternalLinksList = ({ poi, refreshList, isAffiliateLink }) => {
  const { t } = useTranslation()
  const { token } = useAuth()
  const navigate = useNavigate()

  const { logout } = useContext(AuthContext)
  const [poiExternalLinks, setPoiExternalLinks] = useState([])

  const fetchPoiExternalLinks = async () => {
    try {
      const response = await axios.get(
        `${config.apiUrl}poi-external-link?poi=${poi.id}&isAffiliateLink=${isAffiliateLink}`,
      )
      setPoiExternalLinks(response.data)
    } catch (error) {
      console.error('An error occurred while fetching links:', error)
    }
  }

  useEffect(() => {
    const fetchPoiExternalLinks = async () => {
      try {
        const response = await axios.get(
          `${config.apiUrl}poi-external-link?poi=${poi.id}&isAffiliateLink=${isAffiliateLink}`,
        )
        setPoiExternalLinks(response.data)
      } catch (error) {
        console.error('An error occurred while fetching links:', error)
      }
    }

    fetchPoiExternalLinks() // Initial fetch

    // Dependency array includes poi.id and refreshList
  }, [poi.id, refreshList, isAffiliateLink])

  const handleDelete = async (poiExternalLinkId) => {
    try {
      await axios.delete(
        `${config.apiUrl}poi-external-link/${poiExternalLinkId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      // After successful deletion, fetch the updated links
      fetchPoiExternalLinks()
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout()
        navigate(LOGIN_PATH)
      } else if (error.response) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.error('An error occurred DELETE poi-external-link:', error)
      }
    }
  }

  const handleRankingUpdate = async (direction, poiExternalLinkId) => {
    try {
      await axios.put(
        `${config.apiUrl}poi-external-link/${poiExternalLinkId}`,
        { ranking: direction },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      // After successful update, fetch the updated links
      fetchPoiExternalLinks()
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout()
        navigate(LOGIN_PATH)
      } else if (error.response) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.error('An error occurred PUT POI EXTERNAL LINK:', error)
      }
    }
  }

  return (
    <div>
      {poiExternalLinks && poiExternalLinks.length > 0 && (
        <div>
          <h2>{isAffiliateLink ? t('AFFILIATE_LINKS') : t('SEE_ELSEWHERE')}</h2>
          <div className="green-frame">
            {poiExternalLinks.map((poiExternalLink, index) => (
              <ManagePoiExternalLink
                key={index}
                poiExternalLink={poiExternalLink}
                handleDelete={handleDelete}
                handleRankingUpdate={handleRankingUpdate}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ManagePoiExternalLinksList
